<div class="header">
    <div>
        <h1 class="text-center text-white">Spin The Wheel!</h1>
        <h3 class="text-center text-white mb-4">Spin the wheel to win extra prizes or coupons!</h3>
    </div>
</div>

<app-rewards-card-unlock
    *ngIf="locked; else wheelView"
    (unlocked)="onUnlocked()"
></app-rewards-card-unlock>

<ng-template #wheelView>
    <ng-container *ngIf="prizes$ | async as prizes">
        <ng-container *ngIf="(prizes?.length ?? 0) > 0; else noPrize">
            <app-spin-the-wheel
                [prizes]="prizes"
                [winningPrize]="(winningPrize$ | async)"
                [drawWinner]="drawWinner"
                [standalone]="isStandalone"
                (finished)="prizeClaimed.emit()"
            ></app-spin-the-wheel>
        </ng-container>
    </ng-container>

    <ng-template #noPrize>
        <h3 class="text-center m-2">No prizes available. Please continue</h3>
    </ng-template>
</ng-template>
